export const PlacesCounter = ({ camp, inline = false }) => {
  if (!camp) return null;
  if (!camp.is_open) {
    return <p data-testid="places-closed" className="font-display font-bold text-red-400">{camp.sold_out ? "Sold out" : "Registrations closed"}</p>;
  }
  if (inline) return <span data-testid="places-limited-inline" className="accent-text font-medium"> · Limited spaces</span>;
  return (
    <p data-testid="places-limited" className="inline-flex items-center gap-2 rounded-full border border-[var(--accent)]/30 bg-[var(--accent)]/10 px-3 py-1 text-xs font-mono-epl uppercase tracking-wider accent-text">
      <span className="h-1.5 w-1.5 rounded-full bg-[var(--accent)] animate-pulse" />Limited spaces
    </p>
  );
};
